import { render, staticRenderFns } from "./MiscPetition2.vue?vue&type=template&id=210c6ee4&scoped=true&"
import script from "./MiscPetition2.vue?vue&type=script&lang=js&"
export * from "./MiscPetition2.vue?vue&type=script&lang=js&"
import style0 from "./MiscPetition2.vue?vue&type=style&index=0&id=210c6ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c6ee4",
  null
  
)

export default component.exports